import styled from '@emotion/styled'

export const BorderBox = styled.div(({ theme }) => ({
  border: `1px solid ${theme.borderColorBase}`,
  borderRadius: theme.borderRadiusBase,
}))
